// WARNING: DO NOT EDIT. This file is automatically generated by CDP Build. It will be overwritten.

export const cdpenv = {
		"TerminalApi":"https://terminal.surecanpay-rc.com/",
	"TennantAPI":"https://tenant.surecanpay-rc.com/",
	"FilesURL":"",

};
